// extracted by mini-css-extract-plugin
module.exports = {"root":"AddTileButton_root__oShSC","rootSmall":"AddTileButton_rootSmall__1vayp"};